export async function fetchJson(url: string) {
    const result = await fetch(url).then((res) => res.json())
    if (result.ok) {
        return [result]
    }
    return [result, new Error("Fetch failed.")]
}
